import angular from 'angular';
import 'ng-file-upload';
import 'angular-bootstrap';
import 'angular-sanitize';
import 'ui-select';
import './dishesServices';
import '../exhibitors/exhibitorsControllers';

const dishesControllers = angular.module('applicationModule.dishesControllers', [
    'ngSanitize',
    'applicationModule.dishesServices',
    'applicationModule.exhibitorsServices',
    'ui.bootstrap',
    'ui.select'
]);

// Exhibitors List Controller
dishesControllers.controller('DishesProvidersController', ['$scope', '$rootScope', '$state', '$stateParams', '$modal', 'NgTableParams', 'growl', 'Dish', 'Exhibitor', 'AppsoupAPI', 'Permissions', '$translate', function ($scope, $rootScope, $state, $stateParams, $modal, NgTableParams, growl, Dish, Exhibitor, AppsoupAPI, Permissions, $translate) {
    'use strict';
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('dishes');
    $scope.application_id = $stateParams.application_id;

    $scope.provider = Permissions.hasAnyAccess('provider');

    $scope.second_title = false;

    $scope.activeTab = [];

    $scope.dishesType = $stateParams.dishesType;

    $rootScope.dishesTypeLabel = 'MODULES.APPLICATIONS.MODULES.DISHES.TITLES.MAIN';
    $state.current.ncyBreadcrumb.label = $rootScope.dishesTypeLabel;

    $scope.setPageTitle = function () {
        if ($scope.dishesType !== 'exhibitors') {
            $rootScope.pageTitle = $translate.instant('MODULES.APPLICATIONS.MODULES.DISHES.TITLES.MAIN');
        } else {
            $rootScope.pageTitle = $translate.instant('MODULES.APPLICATIONS.MODULES.DISHES.TITLES.PROVIDERS');
        }
    };

    if ($scope.dishesType !== 'exhibitors') {
        $scope.activeTab[0] = true;
        $scope.activeTab[1] = false;
    } else {
        $scope.activeTab[1] = true;
        $scope.activeTab[0] = false;
    }

    $scope.showDishes = function () {
        $scope.dishesType = 'dishes';
        $scope.setPageTitle();

        $scope.writeAccess = Permissions.hasWriteAccess('dishes');
        $scope.provider = Permissions.hasAnyAccess('provider');
        $scope.application_id = $stateParams.application_id;
        $scope.search = {};
        $scope.providers = [];

        $scope.tableParams = new NgTableParams(AppsoupAPI.getDefaultTableParams(), {
            getData: function (params) {
                $scope.isLoading = true;
                return Dish.list($scope.application_id, params._params)
                    .then(function (response) {
                        $scope.providers = response.providers;
                        params.total(response.data.total);
                        params.count(response.data.per_page);
                        params.page(response.data.current_page);
                        return response.data.data;
                    })
                    .finally(function () {
                        $scope.isLoading = false;
                        $scope.isFind = false;
                    });
            },
            counts: AppsoupAPI.getDefaultCounts()
        });

        $scope.removeDish = function (id, index) {
            Dish.remove(id)
                .then(function (response) {
                    const data = response.data || response;
                    if (data.success) {
                        growl.success('MODULES.APPLICATIONS.MODULES.DISHES.GROWL.SUCCESS.DELETE');
                        $scope.tableParams.data.splice(index, 1);
                    } else {
                        growl.error('MODULES.APPLICATIONS.MODULES.DISHES.GROWL.ERROR.DELETE');
                    }
                });
        };

        $scope.second_title = false;
    };

    $scope.showProviders = function () {
        $scope.dishesType = 'exhibitors';
        $scope.setPageTitle();
        $scope.second_title = true;

        $scope.writeAccess = Permissions.hasWriteAccess('exhibitors') || Permissions.hasAnyAccess('provider');
        $scope.application_id = $stateParams.application_id;
        $scope.search = {};

        $scope.tableParams = new NgTableParams(AppsoupAPI.getDefaultTableParams(), {
            getData: function (params) {
                $scope.isLoading = true;
                return Exhibitor.getList($scope.application_id, params._params)
                    .then(function (response) {
                        $scope.categories = response.categories;
                        params.total(response.exhibitors.total);
                        params.count(response.exhibitors.per_page);
                        params.page(response.exhibitors.current_page);
                        return response.exhibitors.data;
                    })
                    .finally(function () {
                        $scope.isLoading = false;
                        $scope.isFind = false;
                    });
            },
            counts: AppsoupAPI.getDefaultCounts()
        });

        $scope.removeExhibitor = function (id, index) {
            Exhibitor.remove(id, $scope.application_id)
                .then(function (response) {
                    const data = response.data || response;
                    if (data.success) {
                        growl.success('MODULES.EXHIBITORS.SUCCESS.DELETE_EXHIBITOR');
                        $scope.tableParams.data.splice(index, 1);
                    } else {
                        growl.error('MODULES.EXHIBITORS.ERROR.DELETE');
                    }
                });
        };

        $scope.remove = function ($event) {
            $event.stopImmediatePropagation();
        };

        $scope.newExhibitor = function () {
            const modalInstance = $modal.open({
                templateUrl: 'views/application/exhibitors/components/modal/exhibitor.tpl.html',
                controller: 'ExhibitorModalController',
                resolve: {
                    exhibitor: function () {
                        return {
                            superadmin: Permissions.hasSuperAdminAccess()
                        };
                    }
                }
            });
            modalInstance.result.then(function () {
                $state.go($state.current, {}, {reload: true});
                growl.success('MODULES.EXHIBITORS.SUCCESS.EXHIBITOR_CREATED');
            }).catch(() => {});
        };

        $scope.searchExhibitors = function (search) {
            $scope.isFind = true;
            const find = angular.copy(search);
            angular.extend($scope.tableParams._params, find);
            $scope.isFind = false;
        };

        $scope.clearSearch = function () {
            $scope.search = {};
            if (angular.isDefined($scope.tableParams._params.name)) {
                $scope.tableParams._params.name = undefined;
            }
            if (angular.isDefined($scope.tableParams._params.category)) {
                $scope.tableParams._params.category = undefined;
            }
        };

        $scope.$watch('search', function () {
            $scope.check = false;
            angular.forEach($scope.search, function (val) {
                if (angular.isDefined(val) && angular.isDefinedNotEmpty(val)) {
                    $scope.check = true;
                }
            });
        }, true);
    };

    if (!$scope.provider) {
        $scope.writeAccess = Permissions.hasWriteAccess('dishes');
        $scope.application_id = $stateParams.application_id;
        $scope.search = {};

        $scope.tableParams = new NgTableParams(AppsoupAPI.getDefaultTableParams(), {
            getData: function (params) {
                $scope.isLoading = true;
                return Dish.list($scope.application_id, params._params)
                    .then(function (response) {
                        $scope.providers = response.providers;
                        params.total(response.data.total);
                        params.count(response.data.per_page);
                        params.page(response.data.current_page);
                        return response.data.data;
                    })
                    .finally(function () {
                        $scope.isLoading = false;
                        $scope.isFind = false;
                    });
            },
            counts: AppsoupAPI.getDefaultCounts()
        });
    }

    $scope.removeDish = function (id, index) {
        Dish.remove(id)
            .then(function (response) {
                const data = response.data || response;
                if (data.success) {
                    growl.success('MODULES.APPLICATIONS.MODULES.DISHES.GROWL.SUCCESS.DELETE');
                    $scope.tableParams.data.splice(index, 1);
                } else {
                    growl.error('MODULES.APPLICATIONS.MODULES.DISHES.GROWL.ERROR.DELETE');
                }
            });
    };
}]);

dishesControllers.controller('EditDishController', ['$scope', '$rootScope', '$state', '$stateParams', 'growl', 'Dish', 'Permissions', function ($scope, $rootScope, $state, $stateParams, growl, Dish, Permissions) {
    'use strict';
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.editMode = false;
    $scope.exhibitor = Permissions.hasAnyAccess('provider');
    $rootScope.dishesTypeLabel = 'MODULES.APPLICATIONS.MODULES.DISHES.TITLES.MAIN';
    const appId = $stateParams.application_id;
    $scope.dish = {
        app_id: $stateParams.application_id
    };
    $scope.exhibitors = [];
    $scope.ingredients = [];
    if (angular.isDefined($stateParams.dish_id)) {
        $scope.editMode = true;
    }
    $scope.upload = undefined;
    $scope.fileUploaded = false;

    Dish.exhibitors(appId)
        .then(function (response) {
            const data = response.data || response;
            if (data.success) {
                $scope.exhibitors = data.data;
                if ($scope.editMode) {
                    Dish.get($stateParams.dish_id)
                        .then(function (response) {
                            const data = response.data || response;
                            if (data.success) {
                                $scope.dish = data.data;
                                if (angular.isDefinedNotNull($scope.dish.image)) {
                                    $scope.fileUploaded = true;
                                }
                            } else {
                                $state.go('appsoup.application.dishes', {application_id: $stateParams.application_id}, growl.error('MODULES.APPLICATIONS.MODULES.DISHES.ERROR.NO_DATA'));
                            }
                        })
                        .catch(function () {
                            $state.go('appsoup.application.dishes', {application_id: $stateParams.application_id}, growl.error('MODULES.APPLICATIONS.MODULES.DISHES.ERROR.NO_DATA'));
                        })
                        .finally(function () {
                            $rootScope.doingResolve = false;
                        });
                }
            } else {
                growl.error('MODULES.APPLICATIONS.MODULES.DISHES.GROWL.ERROR.' + data.error);
            }
        });

    $scope.autocomplete = function (text) {
        text = text.replace('#', escape('#'));
        text = text.toLowerCase().trim();
        Dish.ingredients(appId, text).then(function (result) {
            let data = result.data;

            if (data.success) {
                $scope.ingredients = data.ingredients;
            } else {
                growl.error('MODULES.APPLICATIONS.MODULES.DISHES.GROWL.ERROR.' + data.error);
            }
        });
    };

    $scope.save = function () {
        $scope.$broadcast('show-errors-check-validity');
        $scope.isLoading = true;
        Dish.save($scope.dish, $scope.upload, $scope.editMode)
            .then(function (response) {
                const data = response.data || response;
                if (data.success) {
                    if ($scope.editMode) {
                        growl.success('MODULES.APPLICATIONS.MODULES.DISHES.GROWL.SUCCESS.UPDATED');
                    } else {
                        growl.success('MODULES.APPLICATIONS.MODULES.DISHES.GROWL.SUCCESS.CREATED');
                    }
                    $state.go('appsoup.application.dishes', {application_id: appId});
                } else {
                    if (typeof data.error === 'object') {
                        if (data.error.image) {
                            $scope.fileError = true;
                        }
                        if (data.error.price) {
                            $scope.formErrors = growl.error('MODULES.APPLICATIONS.MODULES.DISHES.ERROR.PRICE');
                        } else {
                            $scope.formErrors = data.error;
                        }
                    } else {
                        growl.error('MODULES.APPLICATIONS.MODULES.DISHES.GROWL.ERROR.CREATED');
                    }
                }
            })
            .finally(function () {
                $scope.isLoading = false;
                $scope.isLoadingMini = false;
            });
    };

    $scope.cancel = function () {
        $state.go('appsoup.application.dishes', {application_id: appId});
    };

    $scope.inputErrors = {
        'name': [{type: '$invalid', msg: 'FORM.ERRORS.REQUIRED'}],
        'price': [{type: '$invalid', msg: 'FORM.ERRORS.REQUIRED'}, {error: 'pattern', msg: 'ERROR.PRICE_FORMAT'}]
    };
}]);

export default dishesControllers;
